export default __webpack_public_path__ + "static/media/services_mobile_app_development_blur.1cea2c52.png";